export const VIEW_JOB_ASSESMANT_MODAL = 'viewJobAssesmentModal';
